import React, { useState, useEffect } from "react";
import Calendar from "react-calendar";
import "../styles/Calendar.css";
import ReservationsModal from "./ReservationsModal";
import SearchModal from "./SearchModal";
import TableManagerModal from "./TableManagerModal";
import FloorplanPrintModal from "./FloorplanPrintModal";
import SettingsModal from "./SettingsModal";

const Sidebar = ({ onDateChange, onNewReservation, onLayoutMode, layoutMode, onRefetchTables, user, onLogout, currentFloor, onFloorChange }) => {
  const [date, setDate] = useState(new Date());
  const [stats, setStats] = useState({
    total_reservations: 0,
    total_guests: 0,
    free_tables: {
      morning_indoor: 0, morning_outdoor: 0,
      afternoon_indoor: 0, afternoon_outdoor: 0,
      evening_indoor: 0, evening_outdoor: 0,
    }
  });
  const [reservations, setReservations] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [showTableManager, setShowTableManager] = useState(false);
  const [showFloorplanPrint, setShowFloorplanPrint] = useState(false);
  const [showSettings, setShowSettings] = useState(false);


  const handleDateChange = (newDate) => {
    setDate(newDate);
    onDateChange(newDate);
  };

  useEffect(() => {
    const fetchStats = () => {
      const formattedDate = date.toLocaleDateString("en-CA");
      fetch(`/reservations/api/reservations/stats/?date=${formattedDate}`)
        .then((res) => res.json())
        .then((data) => setStats(data))
        .catch(() => setStats({ 
          total_reservations: 0, 
          total_guests: 0, 
          free_tables: { morning: 0, afternoon: 0, evening: 0 } 
        }));
    };

    fetchStats(); // odmah

    const interval = setInterval(fetchStats, 30000); // svakih 30 sekundi

    return () => clearInterval(interval); // cleanup
  }, [date]);

  /* ---------------------------------
        POPUP LISTA REZERVACIJA
  ---------------------------------- */
  const openReservationList = () => {
    const formattedDate = date.toLocaleDateString("en-CA");
    fetch(`/reservations/api/reservations/by-date/?date=${formattedDate}`)
      .then((res) => res.json())
      .then((data) => {
        const sorted = (data.reservations || []).sort((a, b) => {
          // Prvo sortiraj po početnom vremenu
          if (a.start_datetime && b.start_datetime) {
            const timeCmp = a.start_datetime.localeCompare(b.start_datetime);
            if (timeCmp !== 0) return timeCmp;
          }

          // Ako je isto vrijeme, sortiraj po imenu stola
          const tableA = a.tables[0] || "";
          const tableB = b.tables[0] || "";
          return tableA.localeCompare(tableB);
        });

        setReservations(sorted);
        setShowModal(true);
      })      
      .catch(() => setReservations([]));
  };

  

  /* ---------------------------------*/
  return (
    <div className="flex flex-col h-full bg-black text-[#c1b428] w-64 p-4 rounded-r-xl shadow-lg">

      {/* LOGO */}
      <div className="flex justify-center mt-0 mb-0">
        <img src="/thehousepub_logo.jpg" alt="Logo" className="w-32 rounded-lg" />
      </div>

      <div className="bg-gray-900 p-2 rounded-lg mb-2">

        {/* KALENDAR */}
        <Calendar
          onChange={handleDateChange}
          value={date}
          className="react-calendar text-[#c1b428] bg-gray-800 border-none"
          tileClassName={({ date: tileDate, view }) => {
            if (view !== "month") return null;

            const today = new Date();
            const isToday =
              tileDate.getDate() === today.getDate() &&
              tileDate.getMonth() === today.getMonth() &&
              tileDate.getFullYear() === today.getFullYear();

            const isSelected =
              tileDate.getDate() === date.getDate() &&
              tileDate.getMonth() === date.getMonth() &&
              tileDate.getFullYear() === date.getFullYear();

            if (isToday) return "tile-today";        // žuta
            if (isSelected) return "tile-selected";  // crvena
            return null;
          }}
        />

        {/* STATISTIKA */}
        <div className="bg-gray-800 rounded-md p-2 mb-2 mt-2 text-xs">
          <div className="flex justify-between"><span>Rezervacija:</span><span className="font-semibold">{stats.total_reservations}</span></div>
          <div className="flex justify-between"><span>Gostiju:</span><span className="font-semibold">{stats.total_guests}</span></div>
          
          {/* Header sa ikonama */}
          <div className="flex justify-between items-center mt-1">
            <span className="font-semibold text-[#c1b428]">Slobodnih stolova:</span>
            <span className="flex gap-3 font-semibold text-[#c1b428]">
              <span>🏠</span>
              <span>🌿</span>
            </span>
          </div>

          {/* Redovi bez ikona */}
          <div className="flex justify-between items-center">
            <span>☀️ Jutro (08-12):</span>
            <span className="flex gap-3 font-semibold">
              <span className="w-4 text-center">{stats.free_tables.morning_indoor}</span>
              <span className="w-4 text-center">{stats.free_tables.morning_outdoor}</span>
            </span>
          </div>
          <div className="flex justify-between items-center">
            <span>🌤️ Poslijepodne (12-20):</span>
            <span className="flex gap-3 font-semibold">
              <span className="w-4 text-center">{stats.free_tables.afternoon_indoor}</span>
              <span className="w-4 text-center">{stats.free_tables.afternoon_outdoor}</span>
            </span>
          </div>
          <div className="flex justify-between items-center">
            <span>🌙 Večer (20-00):</span>
            <span className="flex gap-3 font-semibold">
              <span className="w-4 text-center">{stats.free_tables.evening_indoor}</span>
              <span className="w-4 text-center">{stats.free_tables.evening_outdoor}</span>
            </span>
          </div>
        </div>

        <button
          onClick={openReservationList}
          className="flex items-center gap-2 w-full text-[#c1b428] text-left px-2 py-1 hover:text-white transition font-medium text-[0.8rem]"
        >
          <img src="/icon_reserved.png" alt="Pregled rezervacija" className="w-5 h-5" />
          Pregled rezervacija →
        </button>
        <button
          onClick={() => setShowFloorplanPrint(true)}
          className="flex items-center gap-2 w-full text-[#c1b428] text-left px-2 py-1 hover:text-white transition font-medium text-[0.8rem]"
        >
          <img src="/icon_floorplan.png" alt="Tlocrt rezervacija" className="w-5 h-5" />
          Tlocrt rezervacija →
        </button>
      </div>

      {/* MENU */}
      <div className="flex flex-col gap-1 mt-auto text-[0.8rem]">
        {[
          { text: "Nova rezervacija", icon: "/icon_booking.png", action: onNewReservation, roles: ["moderator", "admin"] },
          { text: "Pretraga rezervacija", icon: "/icon_search_booking.png", action: () => setShowSearchModal(true), roles: ["watcher", "moderator", "admin"] },
          { text: "Dodavanje/brisanje stolova", icon: "/icon_add_table.png", action: () => setShowTableManager(true), roles: ["admin"] },
          { text: "Raspored stolova", icon: "/icon_table.png", action: onLayoutMode, roles: ["admin"] },
        ]
        .filter((item) => user && item.roles.includes(user.role))
        .map((item, idx) => (
          <button
            key={idx}
            onClick={item.action}
            className="flex items-center gap-2 text-[#c1b428] text-left px-2 py-2 hover:text-white transition font-medium"
          >
            <img src={item.icon} alt={item.text} className="w-5 h-5" />
            {item.text}
          </button>
        ))}
      </div>
      {/* Postavke gumb */}
      <button
        onClick={() => setShowSettings(true)}
        className="flex items-center gap-2 text-[#c1b428] text-left px-2 py-2 hover:text-white transition font-medium text-[0.8rem] mt-1"
      >
        <img src="/icon_settings.png" alt="Postavke" className="w-5 h-5" />
        Postavke
      </button>
      {/* Korisnik i logout */}
      <div className="mt-2 pt-2 border-t border-gray-700 text-xs text-gray-400 flex justify-between items-center">
        <span>👤 {user?.username} <span className="text-[#c1b428]">({user?.role})</span></span>
        <button
          onClick={onLogout}
          className="text-red-400 hover:text-red-300 text-xs"
        >
          Odjava
        </button>
      </div>

      {showModal && (
        <ReservationsModal
          date={date}
          reservations={reservations}
          onClose={() => setShowModal(false)}
        />
      )}     

      {showSearchModal && (
        <SearchModal
          onClose={() => setShowSearchModal(false)}
          onReservationChanged={onRefetchTables}  // ✅ dodaj
        />
      )}

      {showTableManager && (
        <TableManagerModal
          onClose={() => setShowTableManager(false)}
          onTableChanged={onRefetchTables} 
        />
      )}

      {showFloorplanPrint && (
        <FloorplanPrintModal
          date={date}
          onClose={() => setShowFloorplanPrint(false)}
        />
      )}      
  
      {showSettings && (
        <SettingsModal
          onClose={() => setShowSettings(false)}
          currentFloor={currentFloor}
          onFloorChange={(floor) => {
            onFloorChange(floor);
          }}
        />
      )}

    </div>
  );
};

export default Sidebar;
